import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from '../components/SectionHeading';
import { Button } from '../components/Button';
import { FAQS } from '../data/site';
interface FAQProps {
  onDownload: () => void;
}
export function FAQ({
  onDownload
}: FAQProps) {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-cream py-20 lg:py-28" data-id="element-496">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-497">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-498">
          <div className="lg:col-span-5" data-id="element-499">
            <SectionHeading eyebrow="Honest answers" title="The questions geologists actually ask." body="No pitch. Just straight answers about what MGS is, who it's for, and what happens when you sign up." data-id="element-500" />
            <div className="mt-7 rounded-xl border border-charcoal/10 bg-sand p-5" data-id="element-501">
              <p className="text-sm font-medium text-charcoal" data-id="element-502">
                Still deciding? Start with the guide.
              </p>
              <Button variant="primary" onClick={onDownload} className="mt-3" data-id="element-503">
                Download the Free MGS Toolkit
              </Button>
            </div>
          </div>

          <div className="lg:col-span-7" data-id="element-504">
            <ul className="divide-y divide-charcoal/10 border-y border-charcoal/10" data-id="element-505">
              {FAQS.map((item, i) => {
              const isOpen = open === i;
              return <li key={item.q} data-id="element-506">
                    <h3 data-id="element-507">
                      <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-5 text-left" data-id="element-508">
                        <span className="text-base font-bold text-charcoal sm:text-lg" data-id="element-509">
                          {item.q}
                        </span>
                        <ChevronDownIcon className={`h-5 w-5 shrink-0 text-charcoal/50 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-510" />
                      </button>
                    </h3>
                    <AnimatePresence initial={false} data-id="element-511">
                      {isOpen && <motion.div initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.25
                  }} className="overflow-hidden" data-id="element-512">
                          <p className="pb-6 pr-8 text-sm leading-relaxed text-warmgray" data-id="element-513">
                            {item.a}
                          </p>
                        </motion.div>}
                    </AnimatePresence>
                  </li>;
            })}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}